import { Collection } from 'modules/core/lib/mobx-rest'

import SurveyForm from 'modules/surveys/store/models/v2/Survey'

class SurveyForms extends Collection<SurveyForm> {
  get cacheKey(): string {
    return 'surveyForms'
  }
  model() {
    return SurveyForm
  }
}

export default new SurveyForms()
